import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { Suspense } from 'react';

const Home = React.lazy(() => import('./Components/Home'));
const Portfolio = React.lazy(() => import('./Components/Portfolio'));
const Services = React.lazy(() => import('./Components/Services'));
const Contact = React.lazy(() => import('./Components/Contact'));
const Resume = React.lazy(() => import('./Components/Resume'));

function App() {
  return (
   <Router>
    <Suspense fallback = {<div>Loading...</div>}>
    <Routes>
      <Route path = '/' element = {<Home/>}/>
      <Route path = '/portfolio' element = {<Portfolio/>}/>
      <Route path = '/services' element = {<Services/>}/>
      <Route path = '/cv' element = {<Resume/>}/>
      <Route path = '/Contact' element = {<Contact/>}/>
    </Routes>
    </Suspense>
   </Router>
  );
}

export default App;
